import axios from 'axios'

export interface IAfspraakInvite {
    id: number
    afspraakId: number
    afspraakTitel: string
    afspraakDatumStart: string
    afspraakDatumEind: string
    vanStamgroepNaam: string
    naarStamgroepNaam: string
    gecreerdeOp: string
    gereageerdOp: string
    status: 'Verstuurd' | 'Geaccepteerd' | 'Geweigerd' | 'Verlopen'
    bericht: string
}

export default class AfspraakInviteService {
    getReceivedAfspraakInvites(stamgroepId: number) {
        return axios.get<IAfspraakInvite[]>(`api/Frontend/Planning/AfspraakUitnodiging/ontvangen/${stamgroepId}`)
    }
    getSentAfspraakInvites(stamgroepId: number) {
        return axios.get<IAfspraakInvite[]>(`api/Frontend/Planning/AfspraakUitnodiging/verstuurd/${stamgroepId}`)
    }
    acceptAfspraakInvite(stamgroepId: number, inviteId: number) {
        return axios.post(`api/Frontend/Planning/AfspraakUitnodiging/accepteer`, {
            stamgroepId: stamgroepId,
            uitnodigingId: inviteId,
        })
    }
    rejectAfspraakInvite(stamgroepId: number, inviteId: number) {
        return axios.post(`api/Frontend/Planning/AfspraakUitnodiging/weiger`, {
            stamgroepId: stamgroepId,
            uitnodigingId: inviteId,
        })
    }
    sendAfspraakInvite({ stamgroepId, afspraakId, naarStamgroepId, bericht }: { stamgroepId: number; afspraakId: number; naarStamgroepId: number; bericht: string }) {
        return axios.post(`api/Frontend/Planning/AfspraakUitnodiging/verstuur`, {
            stamgroepId: stamgroepId,
            afspraakId: afspraakId,
            naarStamgroepId: naarStamgroepId,
            bericht: bericht,
        })
    }
}

export const afspraakInviteService = new AfspraakInviteService()
